'use client'
import { motion } from 'motion/react'
import { styled } from '@repo/ui'

function Svg(props) {
  const { rotate, ...rest } = props
  return (
    <motion.svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="35"
      viewBox="0 0 34 35"
      fill="none"
      animate={{ rotate: rotate ? -45 : 0 }}
      {...rest}>
      <path
        d="M17.7071 11.5061C18.0976 11.1156 18.7308 11.1156 19.1213 11.5061L24.7782 17.1629C25.1687 17.5535 25.1687 18.1866 24.7782 18.5772L19.1213 24.234C18.7308 24.6245 18.0976 24.6245 17.7071 24.234C17.3166 23.8435 17.3166 23.2103 17.7071 22.8198L21.6569 18.87L9.92893 18.87C9.37665 18.87 8.92893 18.4223 8.92893 17.87C8.92893 17.3178 9.37665 16.87 9.92893 16.87L21.6569 16.87L17.7071 12.9203C17.3166 12.5298 17.3166 11.8966 17.7071 11.5061Z"
        fill="white"
      />
    </motion.svg>
  )
}

export const ArrowIcon = styled(Svg)
